import { useContext, useRef, useState } from "react";
import useDelayUnmount from "../../../hooks/useDelayUnmount";
import MultiLanTxt from "../MultiLanTxt/MultiLanTxt";
import classes from "./Button.module.css";
import CircularProgress from "@mui/material/CircularProgress";
import { LanguageContext } from "../../../store/language-context";

const Button = ({
  onClick,
  // isLoading,
  disabled,
  style,
  icon,
  notTranslationalTxt,
  tid,
  smallWidth,
  largeWidth,
  renderIconFromTheEnd,
  btnInlineStyle,
  maxWidth,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const showDiv = useDelayUnmount(isLoading, 250);
  const { userLanguage } = useContext(LanguageContext);
  const loadingRef = useRef(false);

  return (
    <button
      onClick={async (e) => {
        if (onClick) {
          if (!disabled) {
            if (loadingRef.current) return;
            loadingRef.current = true;

            try {
              setIsLoading(true);
              await Promise.resolve(onClick(e));
            } finally {
              loadingRef.current = false; // always resets
              setIsLoading(false);
            }
          }
        }
      }}
      className={[
        classes.btn,
        renderIconFromTheEnd ? classes.ltrDir : null,
        smallWidth ? classes.smallWidth : largeWidth ? classes.largeWidth : classes.normalWidth,
        style === "confirm" || style === "submit"
          ? classes.confirmStyle
          : style === "reject"
            ? classes.rejectStyle
            : style === "completeRejection"
              ? classes.completeRejectStyle
              : style === "cancel"
                ? classes.cancelStyle
                : style === "common"
                  ? classes.commonStyle
                  : classes.commonStyle,
        maxWidth ? classes.maxWidth : "",
      ].join(" ")}
      style={btnInlineStyle ? btnInlineStyle : {}}
    >
      {showDiv ? (
        <span
          className={[
            classes.loading,
            !isLoading ? classes.loadingUnmounted : classes.loadingMounted,
          ].join(" ")}
        >
          <CircularProgress size={25} thickness={5} color="inherit" />
        </span>
      ) : (
        <span
          className={[classes.contentContainer, isLoading ? classes.unmounted : classes.mounted].join(
            " ",
          )}
        >
          {icon ? <span className={classes.iconWrapper}>{icon}</span> : null}
          <span
            className={[
              classes.text,
              icon
                ? style === "completeRejection" || style === "cancel" || userLanguage === "en"
                  ? classes.largeMoveTextOnHover
                  : classes.moveTextOnHover
                : "",
            ].join(" ")}
          >
            {notTranslationalTxt ? notTranslationalTxt : <MultiLanTxt tid={tid} />}
          </span>
        </span>
      )}
    </button>
  );
};

export default Button;
